import React, { useState } from 'react';
import {LeadsModel} from '../models/LeadsModel'
import {SimulatorOfferModel,LeadRider} from '../models/superbit-api-models'
import moment from 'moment';
import { IDNameDescriptionDictionary } from '../models/Site';
import generalSettings from '../json/general-settings.json';

import DropDownIcon from '../components/_DropDownIcon';
import LeadOfferContent from './LeadOfferContent';
import { setReloadLeadTreatments } from '../app-context/leadsSlice';
import { connect } from 'react-redux';
import { RootState } from '../app-context/store';

type Props = {
    offer: SimulatorOfferModel | null;
    getAuthorizedToDriveName: any;
    emailAddress: string;
    onRefreshData: Function;
    openPopupMessage?: Function;
    leadId?: string;
    OpenProduction:string;
    // onProductionClick?: any;

    setReloadLeadTreatments: (value: boolean) => void;
    reloadLeadTreatments: boolean;
};


type State = {
    showBtnOptions: boolean;
    hideCreateRiderOption: boolean;
    InsuranceTypes: IDNameDescriptionDictionary;
    insuranceLabel: string,
};


class LeadOffer extends React.Component<Props, State> {
    leadsModel: LeadsModel = new LeadsModel();

    constructor(props: any) {
        super(props);
        this.state = {
            showBtnOptions: false,
            hideCreateRiderOption: false,
            InsuranceTypes: generalSettings.InsuranceTypes,
            insuranceLabel: '',
        }
    }

    componentDidMount() {
        moment.locale('he');
        const appConfigStr = localStorage.getItem('appConfig');
        if (appConfigStr) {
            const appConfig: any = JSON.parse(appConfigStr);
            this.setState({
                hideCreateRiderOption: appConfig.hideLeadCreateRider
            })
        }
        if (this.props.offer) {
            this.setState({ insuranceLabel: this.getInsuranceLabel() })
        }
    }

    // getNumberOrZero(int: number | undefined | null) {
    //     if (int != null && int != undefined)
    //         return int;
    //     return 0;
    // }


    toggleBtnMenu() {
        if(this.state && this.state.showBtnOptions){

            const curentState = this.state.showBtnOptions;
            this.setState({
                showBtnOptions: !curentState
            })
        }
    }

    // onMenuClick(action: string, value?: string) {
    //     console.log(action);
    //     switch (action) {
    //         case 'sendToEmail':
    //             this.leadsSendMail();
    //             break;
    //         case 'sendToWhatsApp':
    //             this.sendToWhatsApp();
    //             break;
    //         case 'createRider':
    //             this.createRider();
    //             break;

    //         case 'openProduction':
    //             this.openProduction();
    //             break;

    //         default:
    //             break;
    //     }
    //     this.toggleBtnMenu()
    // }

    leadsSendMail() {
        if (this.props.offer) {
            try {
                this.leadsModel.leadsSendMail(this.props.offer.id as string).then((res) => {
                    let textMessage = 'OK';
                    const responseData = JSON.parse(res)
                    console.log(responseData, typeof responseData);
                    if (responseData.code) {
                        if (responseData.code == 200) {
                            textMessage = 'נשלח בהצלחה'
                            this.props.onRefreshData();
                        } else {
                            textMessage = 'שליחה נכשלה'
                        }
                    } else if (typeof responseData == 'string') {
                        textMessage = responseData;
                    }
                    this.openPopupMessage({
                        response: textMessage
                    })
                })
            } catch (error) {

            }
        }
    }

    sendToWhatsApp() {
        console.log('sendToWhatsApp :>> ', this.props);
        if (this.props && this.props.offer) {
            try {
                this.leadsModel.sendToWhatsApp(this.props.offer.id as string).then((res) => {
                    console.log(res);
                    this.props.onRefreshData();
                    this.props.setReloadLeadTreatments(true);

                    let textMessage = 'OK';
                    let responseData = res;
                    try {
                        responseData = JSON.parse(res)
                        console.log(responseData, typeof responseData);
                        if (responseData.code) {
                            if (responseData.code == 200) {
                                textMessage = 'נשלח בהצלחה'
                            } else {
                                textMessage = 'שליחה נכשלה'
                            }
                        } else if (typeof responseData == 'string') {
                            textMessage = responseData;
                        }
                    } catch (error) {
                        textMessage = res
                    }
                    this.openPopupMessage({
                        response: textMessage
                    })
                })
            } catch (error) {

            }
        }
    }

    async createRider() {
        if (this.props.offer) {
            try {
                // this.props.offer.id
                const res: any = await this.leadsModel.createRidersForLead(this.props.offer.id);
                if (res) {
                    if (res.statusCode == 200) {
                        console.log('createRider', res)
                        let loggedUser: any = localStorage.getItem('loggedUser');
                        if (loggedUser) {
                            loggedUser = JSON.parse(loggedUser);
                            const newUrl = `https://dev.superbit.co.il/Account/LoginToPage?userId=${loggedUser.id}&page=/rider%3Fid=${res.statusMessage}`;
                            window.open(newUrl, '_blank');
                        }
                    } else {
                        this.openPopupMessage({
                            response: res.statusMessage
                        })
                    }

                }
            } catch (error) {

            }

        }
    }


    closeLead() { }


    openPopupMessage(d: any) {
        if (this.props.openPopupMessage) {
            this.props.openPopupMessage(d);
        }
    }
    getInsuranceLabel() {
        console.log('getInsuranceLabel')
        let result = '';
        if (this.props.offer && this.props.offer.insuranceType != undefined) {
            console.log('getInsuranceLabel-this.props.offer.insuranceType', this.props.offer.insuranceType)
            const insuranceTypesStr = localStorage.getItem('insuranceTypes');
            if (insuranceTypesStr) {
                const insuranceTypes = JSON.parse(insuranceTypesStr);
                result = insuranceTypes[this.props.offer.insuranceType].name
            }
        }
        return result;
    }

    // openProduction = async () => {

    //     //set id to state
    //     if (this.props.offer && this.props.offer.id) {

    //         this.dispatch(setOfferId(this.props.offer.id))
    //     }
    //     // this.props.onProductionClick(this.props.offer);
    // }


    render() {
        let ridersSum = null;
        if (this.props.offer != null && this.props.offer.riders != null && this.props.offer.riders.length > 0) {
            ridersSum = this.props.offer.riders != null ? this.props.offer.riders.map(x => x.price).reduce(function (a, b) { return a != null && b != null ? a + b : 0; }) : 0;
        }

        return (
            <>

                {this.props.offer != null ? (

                        <LeadOfferContent
                            offer={this.props.offer}
                            leadsSendMail={()=>this.leadsSendMail()}
                            sendToWhatsApp={()=>this.sendToWhatsApp()}
                            createRider={this.createRider}
                            toggleBtnMenu={this.toggleBtnMenu}
                            ridersSum={ridersSum}
                            getAuthorizedToDriveName={this.props.getAuthorizedToDriveName}
                            insuranceLabel={this.state.insuranceLabel}
                            emailAddress={this.props.emailAddress}
                            hideCreateRiderOption={this.state.hideCreateRiderOption}
                            leadId={this.props.leadId}
                           OpenProd={this.props.OpenProduction}
                        />
                    
                ) : ""}

            </>

        );
    }
}


const mapDispatchToProps = (dispatch: any) => {
    return {
      dispatch,
      setReloadLeadTreatments: (value: boolean) => dispatch(setReloadLeadTreatments(value))
    }
  }

const mapStateToProps = (state: RootState) => ({
        reloadLeadTreatments: state.leads.reloadLeadTreatments
})


  export default connect(mapStateToProps, mapDispatchToProps)(LeadOffer);